import { toast } from "vue3-toastify";

const NotificationUtil = {
  createElementSuccessfully() {
    toast.success("Elementet er blevet oprettet!");
  },
  deleteElementSuccessfully() {
    toast.success("Elementet er blevet slettet!");
  },
  updateElementSuccessfully() {
    toast.success("Elementet er blevet opdateret!");
  },
  closeElementSuccessfully() {
    toast.success("Elementet er lukket!");
  },
  reOpenElementSuccessfully() {
    toast.success("Elementet er åben!");
  },
  moveElementSuccessfully() {
    toast.success("Elementet er blevet flyttet!");
  },
  //Relationen er blevet opdateret
  updateRelationShip() {
    toast.success("Relationen er blevet opdateret!");
  },
  notify(object: { text: string; type: string }) {
    if (object.type.trim() === "error") {
      toast.error(object.text);
    }
    if (object.type.trim() === "warn") {
      toast.warning(object.text);
    }
    if (object.type.trim() === "success") {
      toast.success(object.text);
    }
  },
  notify400(message: string) {
    toast.error(`<strong>400</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
  notify401(message: string) {
    toast.error(`<strong>401</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
  notify403(message: string) {
    toast.error(`<strong>403</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
  notify404(message: string) {
    toast.error(`<strong>404</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
  notify409(message: string) {
    toast.error(`<strong>409</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
  notify500(message: string) {
    toast.error(`<strong>500</strong>\n${message}`, {
      dangerouslyHTMLString: true,
    });
  },
};
export default NotificationUtil;
